import { useQuery } from '@tanstack/react-query';

import { docCheDoTrienKhai } from '../lib/che-do-trien-khai';
import type { CheDoTrienKhai } from '../lib/che-do-trien-khai';

/**
 * Chế độ triển khai (`/config.json`). Trong lúc đọc coi như SaaS: màn và băng
 * của bản on-premise hiện muộn một nhịp, còn hơn hiện nhầm ở bản SaaS. Màn chỉ
 * có ở bản on-premise thì xem `daBiet` để chờ, không báo nhầm "chỉ có ở bản
 * on-premise" trong nhịp đó.
 */
export function useCheDoTrienKhai(): { cheDo: CheDoTrienKhai; onPremise: boolean; daBiet: boolean } {
  const { data } = useQuery({
    queryKey: ['che-do-trien-khai'],
    queryFn: docCheDoTrienKhai,
    staleTime: Infinity,
    gcTime: Infinity,
  });
  const cheDo = data ?? 'SAAS';
  return { cheDo, onPremise: cheDo === 'ON_PREMISE', daBiet: data !== undefined };
}
